import { Font } from '@react-pdf/renderer';

export interface FontSources {
  MaisonNeueBook: string;
  MaisonNeueMedium: string;
  MaisonNeueBookItalic: string;
  MaisonNeueBold: string;
  MaisonNeueBoldItalic: string;
}

/**
 * Shared font registration logic used by both browser and Node.js environments
 */
export function registerFonts(sources: FontSources) {
  // Register fonts
  Font.register({
    family: 'MaisonNeue',
    fonts: [
      { src: sources.MaisonNeueBook, fontWeight: 400, fontStyle: 'normal' },
      {
        src: sources.MaisonNeueBookItalic,
        fontWeight: 400,
        fontStyle: 'italic',
      },
      { src: sources.MaisonNeueMedium, fontWeight: 500, fontStyle: 'normal' },
      { src: sources.MaisonNeueBold, fontWeight: 700, fontStyle: 'normal' },
      {
        src: sources.MaisonNeueBoldItalic,
        fontWeight: 700,
        fontStyle: 'italic',
      },
    ],
  });

  Font.register({
    family: 'MaisonNeue-Book',
    src: sources.MaisonNeueBook,
  });

  Font.register({
    family: 'MaisonNeue-Bold',
    src: sources.MaisonNeueBold,
  });

  Font.register({
    family: 'MaisonNeue-Medium',
    src: sources.MaisonNeueMedium,
  });

  Font.register({
    family: 'MaisonNeue-BookItalic',
    src: sources.MaisonNeueBookItalic,
    fontStyle: 'italic',
  });

  Font.register({
    family: 'MaisonNeue-BoldItalic',
    src: sources.MaisonNeueBoldItalic,
    fontStyle: 'italic',
  });

  // Register hyphenation callback: allow long words (e.g. URLs) to break so they wrap
  const MAX_WORD_LENGTH = 40;
  Font.registerHyphenationCallback((word: string) =>
    word.length <= MAX_WORD_LENGTH ? [word] : Array.from(word),
  );
}
